'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        children = props.children,
        theme = props.theme,
        className = props.className,
        btnProps = (0, _objectWithoutProperties3.default)(props, ['size', 'children', 'theme', 'className']);


    return theme ? _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, btnProps, {
            className: (0, _classnames2.default)(theme.button, theme[size], className)
        }),
        children
    ) : null;
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/Button/index.js
// module id = 661
// module chunks = 4 5 8 9 14